export const iconFontAwesomeShoppingBookmark = (
	<i className="fa-solid fa-bookmark"></i>
);
